import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { CORPORATE_EMAIL_ADDRESS } from '@utils/constants';
import { LeadTypes } from '@utils/enums';
import { getImgixSrc } from '@utils/images';

import CorporateLeadForm from '../../Form/CorporateLeadForm';

const IntroAndForm = () => {
  return (
    <div
      id="IntroAndForm"
      className="mx-16 mt-48 flex flex-col items-center gap-48 sm:mx-28 sm:grid sm:grid-cols-2 sm:flex-row sm:items-start sm:gap-56 md:gap-[92px] xl:mx-[200px] xl:mt-64 xl:gap-[198px]"
    >
      <div className="flex flex-col items-center sm:max-w-[300px] md:max-w-[450px]">
        <div className="flex flex-col items-start">
          <h2 className="my-0 font-suisse-works text-headline-xs sm:text-headline-md">
            Group Subscriptions
          </h2>
          <p className="mb-0 mt-8 font-suisse-neue text-body-md sm:mt-16 sm:text-subheadline-md">
            Equip your team with the biggest news and trends before anyone else.
          </p>
        </div>
        <LazyImgixImage
          className="hidden sm:block sm:h-[239px] sm:w-[235px] md:h-[303px] md:w-[298px]"
          role="presentation"
          sizes="(min-width: 992px) 300px, (min-width: 768px) 240px"
          src={getImgixSrc({
            path: 'corporate/logo-circuit-to-avatars.png',
            isEnvDependent: false,
          })}
          wrapperClassName="sm:h-[239px] sm:w-[235px] md:h-[303px] md:w-[298px] !hidden sm:!block sm:mt-28 md:mt-64"
        />
      </div>
      <div className="w-full">
        <CorporateLeadForm
          className="w-[330px] sm:w-full"
          getInTouchEmailAddress={CORPORATE_EMAIL_ADDRESS}
          includeNumberOfUsers={true}
          leadType={LeadTypes.CorporateInbound}
        />
      </div>
    </div>
  );
};

export default IntroAndForm;
